import L from 'leaflet'
import { memo, useMemo } from 'react'
import { GeoJSON } from 'react-leaflet'

import { Map } from '@/components/map'
import { CogTileLayerProxy } from '@/components/map/cog-tile-layer/proxy'
import { Label } from '@/pages/diagnosis-view/components/geo-json-map/label'
import { GeoJSONObject } from '@/types/geospatial'

interface PlantingFailureMapProps {
  perimeter: GeoJSONObject
  mapLabel: string
  children: React.ReactNode
  cogUrl?: string
}

const PlantingFailureMapComponent = ({
  perimeter,
  mapLabel,
  children,
  cogUrl,
}: PlantingFailureMapProps) => {
  const { perimeterBounds, maxBounds } = useMemo(() => {
    const bounds = L.geoJSON(perimeter).getBounds()

    const maxBounds = L.latLngBounds(
      bounds.getSouthWest(),
      bounds.getNorthEast(),
    ).pad(0.6)

    return { perimeterBounds: bounds, maxBounds }
  }, [perimeter])

  return (
    <Map
      bounds={perimeterBounds}
      maxBounds={maxBounds}
      preferCanvas
      whenCreated={(map) => map.setMinZoom(map.getBoundsZoom(maxBounds))}
      zoomSnap={1}
      markerZoomAnimation={false}
      disabledControls={{ attributionControl: true }}
      positionControls={{ attributionControl: 'bottomleft' }}
    >
      <Label title={mapLabel} />

      {cogUrl && <CogTileLayerProxy url={cogUrl} />}

      <GeoJSON
        data={perimeter}
        style={{
          color: '#716FD0',
          weight: 2,
          fillRule: 'nonzero',
          fill: false,
        }}
      />

      {children}
    </Map>
  )
}

export const PlantingFailureMap = memo(PlantingFailureMapComponent)
